<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><em>For the newest little love of my life, Josey Tucker Law</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?3e52a43f